import axios from './axiosService';
import fetchService from './fetchService';

export default {
  getCampaign(campaignID) {
    return axios.get(`/api/mailcoach/campaigns/${campaignID}`)
      .then(response => response.data);
  },
  sendImmediately(campaignID) { // MLD-4785
    return axios.post(`/api/mailcoach/campaigns/${campaignID}/send-immediately`)
      .then(response => response.data);
  },
  cancelCampaign(campaignID) { // MLD-3412
    return axios.post(`/api/mailcoach/campaigns/${campaignID}/cancel`)
      .then(response => response.data);
  },
  deleteCampaign(campaignID) { // MLD-3412
    return axios.delete(`/api/mailcoach/campaigns/${campaignID}`)
      .then(response => response.data);
  },
  getWebhookMetrics(campaignID) { // MLD-2534
    return axios.get(`/api/mailcoach/campaigns/${campaignID}/webhook-metrics`)
      .then(response => response.data);
  },
  async getCampaigns(params = {}) {
    return await fetchService.fetchRecords(`/api/mailcoach/campaigns`, params, 100); // MLD-7505
  },
  createList(form) { // MLD-4958
    return axios.post(`/api/mailcoach/lists`, form)
      .then(response => response.data);
  },
  getList(listID) {
    return axios.get(`/api/mailcoach/lists/${listID}`)
      .then(response => response.data);
  },
  getListsForUser(userID, params = {}) {
    params.user_id = userID;
    return this.getLists(params);
  },
  async getLists(params = {}) {
    return await fetchService.fetchRecords(`/api/mailcoach/lists`, params, 100);
  },
  /**
   * Fetches all subscribers from a specified mailing list in paginated batches.
   * Utilizes concurrency for improved performance when handling large datasets.
   *
   * @param {string} listID - The identifier of the mailing list to retrieve subscribers from.
   * @param {Object} [params={}] - Optional query parameters to filter or modify the request.
   * @param {number} [batchSize=1000] - Number of subscribers to fetch per batch.
   * @param {number} [concurrentRequests=4] - Number of concurrent requests to make during fetching.
   * @return {Promise<Array>} A promise that resolves to an array containing all subscribers.
   */
  async getAllSubscribers(listID, params = {}, batchSize = 1_000, concurrentRequests = 4) {
    // MLD-7505 use the fetchService.
    return await fetchService.fetchRecords(`/api/mailcoach/lists/${listID}/subscribers`, params, batchSize, concurrentRequests);
  },
  async getActiveListSubscribers(listID, min = 0, limit = 0) { // MLD-2844
    // MLD-7502
    const config = {
      params: {
        min: min,
        limit: limit,
        status: 'Active',
      }
    }
    const {data} = await axios.get(`/api/mailcoach/lists/${listID}/subscribers`, config)
    return data;
  },
  async exportCampaigns(params = {}, filename = 'campaigns.csv') { // MLD-2534
    return axios.get(`/api/mailcoach/campaigns/export`, {params: params})
      .then(response => {
        const data = response.data;
        // https://stackoverflow.com/questions/43432892/force-download-get-request-using-axios
        const blob = new Blob([data], {type: 'text/csv'});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
        return data;
      })
  },
  addContacts(listID, contactIDs) { // MLD-3147
    const form = {
      contacts: contactIDs,
    }
    return axios.post(`/api/mailcoach/lists/${listID}/contacts`, form)
      .then(response => {
        return response.data;
      })
  },
  copyList(listID, form) { // MLD-3318
    return axios.post(`/api/mailcoach/lists/${listID}/copy`, form)
      .then(response => {
        return response.data;
      });
  }
}
